<template>
  <div class="number-group">
		<div class="minus-btn" :class="{'disabled':selectedCount==minNum}" @click.stop="minusNum">-</div>
		<label @click.stop="">
			<mt-field :disableClear="true" placeholder="" type="number" v-model="selectedCount" @change="changeNum(maxNum)"></mt-field>
		</label>
		
		<div class="add-btn" :class="{'disabled':selectedCount>=maxNum}" @click.stop="addNum(maxNum)">+</div>
	</div>
</template>

<script>
	export default {
    name: '',
    data () {
      return {
      	selectedCount:1
      }
    },
    props:{
    	maxNum:{
    		type:Number,
    		default:1
    	},
    	minNum:{
    		type:Number,
    		default:1
    	},
    	orNum:{
    		type:Number,
    		default:1
    	}
    },
    mounted(){
    	this.selectedCount=this.orNum;
    },
    methods:{
    	minusNum(){
    		if(this.selectedCount<=this.minNum) return;
    		this.selectedCount=this.selectedCount-1;
    		this.$emit('changeNum',this.selectedCount);
    	},
    	addNum(maxNum){
    		if(this.selectedCount==maxNum) return;
    		this.selectedCount=this.selectedCount+1;
    		this.$emit('changeNum',this.selectedCount);
    	},
    	changeNum(maxNum){
    		if(this.selectedCount<this.minNum){
    			this.selectedCount=1;
    		}else if(this.selectedCount>maxNum){
    			this.selectedCount=maxNum;
    		}
    		this.$emit('changeNum',this.selectedCount);
    	}
    },
    components:{
        
    }
  }
</script>
<style>
	.number-group .mint-cell{
		min-height: auto;
		min-width: .4rem;
	}
	.number-group .mint-field-core{
		max-width: .4rem;
		height: .26rem;
		appearance: textfield;
		text-align: center !important;
	}
	.number-group .mint-cell-wrapper{
		padding: 0;
	}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
.number-group{
	width: 1rem;
	display: flex;
	align-items:stretch;
	border: 1px solid #ddd;
	border-radius: 5px;
	background-color: #ddd;
	overflow: hidden;
	label{
		background-color: #fff;
	}
	.mint-cell-value{
		height: 100%;
	}
	.minus-btn,.add-btn{
		display: block;
		padding: 0 .1rem;
		font-size: .18rem;
		height: .29rem;
		line-height:.29rem;
		border:none;
		background-color: #ddd;
		&:active{
			background-color: #ccc;
		}
		&.disabled{
			background-color:#fff;
			&:active{
				background-color: #fff;
			}
		}
	}
	.minus-btn{
		border-right: 1px solid #ddd;
	}
	.add-btn{
		border-left: 1px solid #ddd;
	}
}
</style>


// WEBPACK FOOTER //
// src/basic/numberSelector/numberSelector.vue